// Number of loops to show per page in the modal.
export const PAGE_SIZE = 10;
